import * as React from 'react'
/*
	you are redirect here if the url is wrong
*/

export default class NotFound extends React.Component {

    render () {
		console.log(window.location.pathname);
		return (
			<h1>Not Found</h1>
		);
    }

}